import firebase from '../firebase';

import 'firebase/firestore';
import 'firebase/auth';

const auth = firebase.auth();
//const firestore = firebase.firestore();


function ChatMessage(props: any) {

    const { text, uid } = props.message;
    //we're saying currentUser is not null - can this be an issue?

    const messageClass = uid === auth.currentUser!.uid ? 'sent' : 'received';

    return (
        <div className={`message ${messageClass}`}>
            {text}
        </div>
    )
}

export default ChatMessage;